import React, { Component } from 'react';
import api from '../utils/api';
import AddressForm from './MemberAddressForm';

class NewReceipt extends Component {
    constructor(props) {
        super(props);
        const { searchCriteria, currentPage } = props.location.state || {};
        // Get the current date in UTC
        const now = new Date();

        // Convert to Pacific Time (UTC-7 or UTC-8 depending on daylight saving time)
        const offset = -7; // PDT (Pacific Daylight Time) offset in hours
        const pacificTime = new Date(now.getTime() + offset * 60 * 60 * 1000);

        // Format the date to YYYY-MM-DD
        const today = pacificTime.toISOString().split('T')[0];
        this.state = {
            memberId: '',
            first1: '',
            middle1: '',
            last1: '',
            first2: '',
            middle2: '',
            last2: '',
            address: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            phone1: '',
            phone2: '',
            email: '',
            memberType: '',
            totalDonation: '',
            lastDonation: '',
            lastDonationDate: '',
            receiptDate: today,
            donationAmt: '',
            modeOfPayment: '1',
            paymentReference: 'Cash',
            description: '',
            descriptionOptions: [], // <-- Add this
            error: '',
            successMessage: '',
            searchCriteria: searchCriteria || {},
            currentPage: currentPage || 1,

        };
        this.onChangeInput = this.onChangeInput.bind(this);
    }

    onChangeInput(e) {
        const { name, value } = e.target;

        // Handle modeOfPayment change to update default paymentReference
        if (name === 'modeOfPayment') {
            let paymentReference = '';
            switch (value) {
                case '1':
                    paymentReference = 'Cash';
                    break;
                case '2':
                    paymentReference = 'Check#: ';
                    break;
                case '3':
                    paymentReference = 'Credit Card Conf#: ';
                    break;
                case '4':
                    paymentReference = 'Bank Direct Deposit Ref#: ';
                    break;
                case '5':
                    paymentReference = 'Other#: ';
                    break;
                default:
                    paymentReference = '';
            }

            this.setState({
                [name]: value,
                paymentReference: paymentReference // Set default value
            });
        } else {
            // Handle changes for other input fields
            this.setState({
                [name]: value
            });
        }
    }

    componentDidMount() {
        const { memberId } = this.props.match.params;
        this.setState({ memberId }, this.fetchMemberDetails);
        this.fetchDescriptionOptions(); // <-- Fetch reference values for description
    }

    fetchDescriptionOptions = async () => {
        try {
            // Fetch reference type id for 'Donation Category'
            const typesRes = await api.get('/api/reference_types');
            const donationCategoryType = typesRes.data.find(t => t.type_name === 'Donation Category');
            if (!donationCategoryType) {
                this.setState({ descriptionOptions: [] });
                return;
            }
            // Fetch reference values for this type
            const res = await api.get('/api/reference_values', { params: { type_id: donationCategoryType.id } });
            const options = (res.data || [])
                .filter(opt => opt.is_active)
                .sort((a, b) => a.display_order - b.display_order);
            // ✅ Find GF (General Fund)
            const gfOption = options.find(opt => opt.key_name === 'GF');

            this.setState({
                descriptionOptions: options,

                // ✅ Set default ONLY if not already set
                description: gfOption
                    ? (gfOption.value || gfOption.key_name)
                    : ''
            });
        } catch (err) {
            // fallback: empty options
            this.setState({ descriptionOptions: [] });
        }
    };

    fetchMemberDetails = () => {
        const { memberId } = this.state;

        api.get(`/api/members/${memberId}`)
            .then((response) => {
                const memberData = response.data.data;
                this.setState({
                    first1: memberData.first1,
                    middle1: memberData.middle1,
                    last1: memberData.last1,
                    first2: memberData.first2,
                    middle2: memberData.middle2,
                    last2: memberData.last2,
                    address: memberData.address,
                    address2: memberData.address2,
                    city: memberData.city,
                    state: memberData.state,
                    zip: memberData.zip,
                    country: memberData.country,
                    phone1: memberData.phone1,
                    phone2: memberData.phone2,
                    email: memberData.email,
                    memberType: memberData.memberType,
                    totalDonation: memberData.totalDonation,
                    lastDonation: memberData.lastDonation,
                    lastDonationDate: memberData.lastDonationDate,
                    error: '',
                    successMessage: ''
                });
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    this.setState({ error: 'No member account found. Please enter a valid member account number.' });
                } else {
                    this.setState({ error: 'Failed to fetch member details. Please try again later.' });
                }
            });
    }

    handleBack = () => {
        const { searchCriteria, currentPage } = this.state;
        this.props.history.push({
            pathname: '/members',
            state: { searchCriteria, currentPage }
        });
    };

    formatDonationAmount = (event) => {
        let value = event.target.value;

        if (value && !value.includes('.')) {
            value = `${value}.00`;
        } else if (value && value.split('.')[1].length === 1) {
            value = `${value}0`;
        }

        this.setState({ donationAmt: value });
    };

    addReceipt = (event) => {
        event.preventDefault();
        if (this.validateField()) {
            // Proceed with save logic
            //console.log('Form is valid. Proceed with save.');
            const { receiptDate, donationAmt, modeOfPayment, paymentReference, description, ...memberData } = this.state;
            const data = { ...memberData, receiptDate, donationAmt, modeOfPayment, paymentReference, description };


            api.post(`/api/receipts`, data)
                .then((response) => {
                    console.log(response);
                    // Assuming the response contains the receipt number
                    const receiptNumber = response.data.data.receiptNum;
                    // Update state to show success message
                    this.setState({
                        successMessage: `Donation saved successfully! Receipt Number: ${receiptNumber}`,
                        error: '' // Clear any previous errors
                    });
                    // Navigate to show receipt details page after 3 seconds
                    const { searchCriteria, currentPage } = this.state;
                    this.props.history.push({
                        pathname: `/receiptDetails/${receiptNumber}`,
                        state: { searchCriteria, currentPage }
                    });
                })
                .catch((error) => {
                    console.error("Error adding receipt:", error);
                    this.setState({ error: 'Error adding donation. Please try again later.' });
                });
        }
        else {
            console.log('Form is invalid. Unable to save. Please check error message.');
        }
    };

    validateField = () => {
        const { donationAmt, receiptDate, description } = this.state;
        let error = '';

        if (donationAmt === '') {
            error = 'Donation amount is required';
        } else if (donationAmt <= 0) {
            error = 'Donation amount must be greater than 0';
        }

        if (!receiptDate) {
            error = 'Receipt date is required';
        } else if (new Date(receiptDate) < new Date('1992-01-01')) {
            error = 'Receipt date cannot be before 1992';
        }

        if (description === '') {
            error = 'Description is required';
        }

        this.setState({ error });
        return error === ''; // Return true if no error
    }



    render() {
        const { successMessage, error, receiptDate, donationAmt, modeOfPayment, paymentReference, description, memberId, first1, middle1, last1, first2, middle2, last2, totalDonation, lastDonation, lastDonationDate, address, address2, city, state, zip, country, phone1, phone2, email, memberType, descriptionOptions } = this.state;

        return (
            <div className="p-0">
                <div className="p-4 border border-secondary">
                    {/* Display success message if it exists */}
                    {successMessage && (
                        <div className="alert alert-success" role="alert">
                            {successMessage}
                        </div>
                    )}

                    {/* Display error message if it exists */}
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}
                    <div className="button-container">
                        <button className="btn btn-primary my my-sm-2 m-1" onClick={this.addReceipt}>Save Donation</button>
                        <button className="btn btn-primary my-2 my-sm-2 m-1" onClick={this.handleBack}>Go Back</button>
                    </div>
                    <div style={{ backgroundColor: "lightgreen" }}>
                        <div className="text-center bold-text">Receipt Details</div>
                        <div className="form-row p-3">
                            <div className="col">
                                <div className="md-form">
                                    <label htmlFor="receiptDate">Receipt Date <span className="text-danger">*</span></label>
                                    <input
                                        onChange={this.onChangeInput}
                                        type="date"
                                        id="receiptDate"
                                        name="receiptDate"
                                        className="form-control"
                                        value={receiptDate}
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div className="md-form">
                                    <label htmlFor="donationAmt">
                                        Donation Amount <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        onChange={this.onChangeInput}
                                        onBlur={this.formatDonationAmount} // Add onBlur handler
                                        type="number"
                                        id="donationAmt"
                                        placeholder="Donation Amount"
                                        name="donationAmt"
                                        className="form-control"
                                        value={donationAmt || ''} // Ensure it doesn't show "undefined" if the state is empty
                                        step="0.01"
                                    />
                                </div>
                            </div>
                            <div className="col">
                                <div className="md-form">
                                    <label htmlFor="modeOfPayment">Mode of Payment <span className="text-danger">*</span></label>
                                    <select
                                        onChange={this.onChangeInput}
                                        id="modeOfPayment"
                                        name="modeOfPayment"
                                        className="form-control"
                                        value={modeOfPayment}
                                    >
                                        <option value="1">Cash</option>
                                        <option value="2">Check</option>
                                        <option value="3">Credit Card</option>
                                        <option value="4">Bank Direct Deposit</option>
                                        <option value="5">Other</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="form-row p-3">
                            <div className="col">
                                <div className="md-form">
                                    <label htmlFor="paymentReference">Check/CC-Ref#</label>
                                    <input
                                        onChange={this.onChangeInput}
                                        type="text"
                                        id="paymentReference"
                                        placeholder="paymentReference"
                                        name="paymentReference"
                                        className="form-control"
                                        value={paymentReference}
                                        list="paymentReferenceSuggestions"
                                    />
                                    <datalist id="paymentReferenceSuggestions">
                                        <option value="Cash" />
                                        <option value="Check # :" />
                                        <option value="Credit Card Conf # :" />
                                        <option value="Bank Direct Deposit Ref# :" />
                                    </datalist>
                                </div>
                            </div>
                            <div className="col">
                                <div className="md-form">
                                    <label htmlFor="description">Description <span className="text-danger">*</span></label>
                                    <select
                                        onChange={this.onChangeInput}
                                        id="description"
                                        name="description"
                                        className="form-control"
                                        value={description}
                                    >
                                        {descriptionOptions.map(opt => (
                                            <option key={opt.id} value={opt.value || opt.key_name}>
                                                {opt.value || opt.key_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ItemDetail">
                        <div className="text-center">Member</div>
                        <div className="form-row p-3">
                            <div className="col">
                                <div className="m-3">
                                    <div>Member Account #</div>
                                    <div className="memberinfo">
                                        {memberId}
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="m-3">
                                    <div>Name</div>
                                    <div className="memberinfo">{first1} {middle1} {last1}</div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="m-3">
                                    <div>Spouse</div>
                                    <div className="memberinfo">
                                        {first2} {middle2} {last2}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ItemDetail">
                        <div className="text-center">Donation History Summary</div>
                        <div className="form-row p-3">
                            <div className="col">
                                <div className="m-3">
                                    <div>Lifetime Donation</div>
                                    <div className="memberinfo">
                                        {totalDonation}
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="m-3">
                                    <div>Last Donation</div>
                                    <div className="memberinfo">
                                        {lastDonation}
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="m-3">
                                    <div>Last Donation Date</div>
                                    <div className="memberinfo">
                                        {lastDonationDate}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AddressForm
                        address={address}
                        address2={address2}
                        city={city}
                        state={state}
                        zip={zip}
                        country={country}
                        phone1={phone1}
                        phone2={phone2}
                        email={email}
                        memberType={memberType}
                        onChangeInput={this.onChangeInput}
                    />
                </div>
            </div>
        );
    }
}
export default NewReceipt;